/* PowerSamoray — undo instant tap feedback when the tap is cancelled.

   Two controls react on pointerdown so they feel instant:
   - the search button dims the page (ps-search-container-transform.js);
   - a language button moves the underline to itself (snippets/ps-language-selector.liquid).

   If the finger then scrolls the page or slides away, no click follows. Before, that feedback
   stayed on screen: the page stayed dimmed although search never opened, and the underline
   stayed on a language that was never switched to. This file only undoes that leftover state.
   A real tap (a click follows) is left completely alone. */

(() => {
  if (window.psTouchCancelGuardsReady) return;
  window.psTouchCancelGuardsReady = true;

  const SEARCH_OPENER = '.search-modal__button';
  const LANGUAGE_BUTTON = '.ps-language__form button[name="language_code"]';
  /* A click, when there is one, arrives right after pointerup. */
  const CLICK_WINDOW_MS = 350;

  /** The press in progress: what was touched, and whether a click followed. */
  let press = null;

  const undoSearchDim = () => {
    const dialog = document.querySelector('#search-modal .search-modal__content');
    if (dialog instanceof HTMLDialogElement && (dialog.open || dialog.classList.contains('dialog-closing'))) return;
    document.getElementById('ps-search-page-underlay')?.classList.remove('is-visible');
  };

  const undoLanguageMark = (button) => {
    const current = button.closest('[data-ps-language-selector]')?.dataset.currentLanguage;
    if (!current || !button.form) return;
    button.form.querySelectorAll('button[name="language_code"]').forEach((item) => {
      item.setAttribute('aria-pressed', item.value === current ? 'true' : 'false');
    });
  };

  const undo = (finished) => {
    if (finished.clicked) return;
    if (finished.search) undoSearchDim();
    if (finished.language?.isConnected) undoLanguageMark(finished.language);
  };

  /* Listeners sit on window (capture) so they also run when another script stops the event. */
  window.addEventListener('pointerdown', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const search = Boolean(target.closest(SEARCH_OPENER));
    const language = target.closest(LANGUAGE_BUTTON);
    press = search || language ? { search, language, clicked: false } : null;
  }, { capture: true, passive: true });

  window.addEventListener('click', () => {
    if (press) press.clicked = true;
  }, { capture: true });

  window.addEventListener('pointercancel', () => {
    const finished = press;
    press = null;
    if (finished) undo(finished);
  }, { capture: true, passive: true });

  window.addEventListener('pointerup', () => {
    const finished = press;
    if (!finished) return;
    setTimeout(() => {
      if (press === finished) press = null;
      undo(finished);
    }, CLICK_WINDOW_MS);
  }, { capture: true, passive: true });
})();
